module.exports = __webpack_public_path__ + "img/icp.f1599c4e.jpg";